document.addEventListener("DOMContentLoaded", function () {
  const mobileMainMenu = document.querySelector('#mobile-main-menu');
  const mobileSubmenu = document.querySelector('#mobile-boutique-submenu');
  const backBtn = document.querySelector('.back-to-menu');

  if (!mobileMainMenu || !mobileSubmenu) return;

  // Toujours afficher le menu principal au début
  mobileMainMenu.style.display = 'block';
  mobileSubmenu.style.display = 'none';

  setTimeout(() => {
    const boutiqueLink = mobileMainMenu.querySelector('a[href="/collections/all"]');
    if (!boutiqueLink) return;

    boutiqueLink.removeAttribute('href');
    boutiqueLink.style.cursor = 'pointer';

    boutiqueLink.addEventListener("click", function (e) {
      e.preventDefault();

      mobileMainMenu.style.display = 'none';
      mobileSubmenu.style.display = 'flex';
    });
  }, 500);

  backBtn?.addEventListener("click", () => {
    mobileSubmenu.style.display = 'none';
    mobileMainMenu.style.display = 'block';
  });
});
